import request from '../api';
interface UserTradeDto {
  area?: string; // 区域
  trade?: string; // 行业
  profession?: string; // 职业
}
function getUserId() {
  // 从本地存储获取userInfo
  const userInfo = localStorage.getItem('userInfo');
  if (userInfo) {
    return JSON.parse(userInfo).userId;
  }
  return '123';
}

// 通用文案助手请求
export const fetchCopywritingAssistant = async (requestData: any, inputs: any) => {
  const { url, method, headers } = requestData;
  const response = await fetch(url, {
    method: method || 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...headers,
    },
    body: JSON.stringify({
      inputs,
      user: getUserId(),
      response_mode: 'blocking',
    }),
  });
  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response;
};

// 智能审查
const smartReviewToken = 'Bearer app-jlyaVpRElo3m72YZUMICNNaV';
export const fetchSmartReview = async (inputs: any) => {
  const response = await fetch('/ai/v1/workflows/run', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': smartReviewToken,
    },
    body: JSON.stringify({
      inputs,
      user: getUserId(),
      response_mode: 'blocking',
    }),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }
  return response;
};

// 生成图片
const aiImageToken = 'Bearer app-siSTQMhKC8APxIduWTn0Te4Y';
export const fetchGenerateAiImage = async (inputs: any) => {
  const response = await fetch('/ai/v1/workflows/run', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': aiImageToken,
    },
    body: JSON.stringify({
      inputs,
      user: getUserId(),
      response_mode: 'blocking',
    }),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response;
};

// 小红书文案生成
const xhsPublicToken = 'Bearer app-kPLOzluLwPVdtZC4KBnr3c2f';
export const fetchPublicXhs = async (inputs: any) => {
  const response = await fetch('/ai/v1/workflows/run', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': xhsPublicToken,
    },
    body: JSON.stringify({
      inputs,
      user: getUserId(),
      response_mode: 'blocking',
    }),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response;
};

// 润色
const grammarToken = 'Bearer app-i7721zK0Fgzel8RJD2grGQa0';
export const fetchUpdateGrammar = async (params: any) => {
  const response = await fetch('/ai/v1/workflows/run', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': grammarToken,
    },
    body: JSON.stringify({
      ...params,
      user: getUserId(),
    }),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response;
};

// 修饰
const toneToken = 'Bearer app-v1vwHk5QxOQzYXeo70kn2hcx';
export const fetchUpdateTone = async (params: any) => {
  const response = await fetch('/ai/v1/workflows/run', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': toneToken,
    },
    body: JSON.stringify({
      ...params,
      user: getUserId(),
    }),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response;
};

// 提示词生成
const PromptGenerateToken = 'Bearer app-o9FvMs01HcNa69amamWbu5td';
export const fetchPromptGenerate = async (params: any) => {
  const response = await fetch('/ai/v1/workflows/run', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': PromptGenerateToken,
    },
    body: JSON.stringify(params),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response;
};
// 获取App用户信息
export const fetchGetAppUserInfo = () => {
  return request.post('/app/user/getProfile', {});
};

// 更新用户区域、行业、职业
export const fetchUpdateTrade = (params: UserTradeDto) => {
  return request.post('/app/user/updateTrade', params);
};

// 获取字典赛道列表
export const fetchTrackList = () => {
  return request.post('/app/sysDict/getAppSysDictList', { dictCode: 'user_industry_types' });
};

// 生成视频TDK
const generateVideoTDKToken = 'Bearer app-fBAU1O4pqDP2oX4MsMDSpgt2';
export const generateVideoTDK = async (params: any) => {
  const response = await fetch('/ai/v1/workflows/run', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': generateVideoTDKToken,
    },
    body: JSON.stringify(params),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response;
};
